module.exports = __webpack_public_path__ + "img/ios-notifications.3b85b0a8.svg";